import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { PRESETS } from "@/lib/stickerDesign";

const FIELDS = [["page_w", "Page width (in)"], ["page_h", "Page height (in)"], ["cols", "Columns"], ["rows", "Rows"], ["label_w", "Sticker width (in)"],
  ["label_h", "Sticker height (in)"], ["margin_top", "Top margin (in)"], ["margin_left", "Left margin (in)"], ["gap_x", "Gap across (in)"], ["gap_y", "Gap down (in)"]];

export default function SheetSetup({ sheet, setSheet }) {
  const preset = Object.keys(PRESETS).find((k) => FIELDS.every(([f]) => PRESETS[k].sheet[f] === sheet[f])) || "custom";
  return (
    <div className="space-y-3" data-testid="sheet-setup">
      <div className="space-y-1.5">
        <Label>Sticker sheet</Label>
        <Select value={preset} onValueChange={(v) => v !== "custom" && setSheet({ ...PRESETS[v].sheet })}>
          <SelectTrigger data-testid="sheet-preset-select"><SelectValue /></SelectTrigger>
          <SelectContent className="bg-card">
            {Object.entries(PRESETS).map(([k, p]) => <SelectItem key={k} value={k}>{p.label}</SelectItem>)}
            <SelectItem value="custom">Custom / my own sheet</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="grid grid-cols-2 gap-2">
        {FIELDS.map(([f, label]) => (
          <div key={f} className="space-y-1">
            <Label className="text-xs text-muted-foreground">{label}</Label>
            <Input type="number" step={["cols", "rows"].includes(f) ? 1 : 0.01} value={sheet[f]} className="h-8 font-mono"
              onChange={(e) => setSheet({ ...sheet, [f]: ["cols", "rows"].includes(f) ? Math.max(1, parseInt(e.target.value, 10) || 1) : parseFloat(e.target.value) || 0 })}
              data-testid={`sheet-${f}`} />
          </div>
        ))}
      </div>
    </div>
  );
}
